
import { AgGridReact } from 'ag-grid-react';
import { UrlPath } from "../../../config/routeConfig";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap'
import { sbaAxios } from '../../utils/sbaAxios';
import { EmailruleInsertorUpdate, deleteEmailrule, getCustomSettings } from "../../../config/apiConfig";
import { ToastContainer } from 'react-toastify';
import { getEmailRules } from '../../actions/emailRulesAction';
import { SBNotify } from '../../utils/sbNotify';
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBGrid } from '../../UiComponents/SBAAGgrid';
import {component} from '../../../config/componentConfig';
import { useRef } from 'react';

export const EmailRulesGridContainer = ({ ActiveTab, setRender, render }) => {
  const [activeTab, setActiveTab] = useState(parseInt(ActiveTab) || 1);
  const dispatch = useDispatch();
  const history = useNavigate();
  const Gstate = useSelector(state => state);
  const isEditable = Gstate.authorizationData.isEditable;
  const EmailRules = Gstate.emailRules.emailRules;
  const [isEdit, setIsEdit] = useState();
  const [showDrawer, setShowDrawer] = useState(false);
  const [copiedName, setCopiedName] = useState("");
  const [newName, setNewName] = useState("");
  const [selectedRowData, setSeletctedRowData] = useState("");
  const [selectedButton, setSelectedButton] = useState('Active');
  useEffect(() => {
    setActiveTab(parseInt(ActiveTab) || 1);
    setSelectedButton('Active');
  }, [ActiveTab]);
  useEffect(()=>{
    setIsEdit(isEditable)
  },[isEditable]);

  useEffect(() => {
    if (selectedButton === "All")
    {
      dispatch(getEmailRules(activeTab, null, null));
    }
    else if
    (selectedButton === "Active")  {
      dispatch(getEmailRules(activeTab, null, true));
    }
  }, [selectedButton, isEdit]);
  
  const ActiveButtons = [
    { value: "0", label: "Active" },
    { value: "1", label: "All" },
  ];
  const NavigatetoAddRule = () => {
    history(`${UrlPath.AddEmailRules}`, {
      state: activeTab
    });
  };
  const fetchActiverecords = (type) => {
    if (type === "Active") {
      setSelectedButton("Active");
      dispatch(getEmailRules(activeTab, null, true));
    }
    else {
      setSelectedButton("All");
      dispatch(getEmailRules(activeTab, null, false));
    }
  };
  const MainMenuRowClicked = (event) => {
    setSeletctedRowData(event.data);
  };
  const copyRuleOnClick = () => {
    if (selectedRowData?.length !== 0) {
      if (activeTab === 1) {
        setCopiedName("Investment Email Rule");
        setShowDrawer(true);
      } else if (activeTab === 2) {
        setCopiedName("Client Email Rule");
        setShowDrawer(true);
      } else if (activeTab === 3) {
        setCopiedName("Deletion Email Rule");
        setShowDrawer(true);
      }
    }
  };
    const saveNewRule = async () => {
    const data = {
      EmailRuleId: 0,
      EmailRuleName: newName,
      EmailRuleTypeId: selectedRowData.EmailRuleTypeId,
      IsActive: selectedRowData.IsActive,
      FilterFromAddresses: selectedRowData.FilterFromAddresses,
      FilterToAddresses: selectedRowData.FilterToAddresses,
      FilterCCAddresses: selectedRowData.FilterCCAddresses,
      FilterFromDomains: selectedRowData.FilterFromDomains,
      FilterSubjectContains: selectedRowData.FilterSubjectContains,
      FilterBodyContains: selectedRowData.FilterBodyContains,
      FilterAttachmentContains: selectedRowData.FilterAttachmentContains,
      DocumentTypeId: selectedRowData.DocumentTypeId,
      SourceEmail: selectedRowData.SourceEmail,
      AccountIdList: selectedRowData.AccountIdList,
      AssetIdList: selectedRowData.AssetIdList,
      SubjectOverride: selectedRowData.SubjectOverride,
      DateOverrideFormat: selectedRowData.DateOverideFormat,
      IsAttachmentOnly: selectedRowData.IsAttachmentOnly,
      IsLinkedEmail: selectedRowData.IsLinkedEmail,
      LinkedEmailFieldId: selectedRowData.LinkedEmailFieldId,
      LinkedEmailFieldContain: selectedRowData.LinkedEmailFieldContain,
      IsStandardConfiguration: selectedRowData.IsStandardConfiguration,
      emailAttachmentSecurityId: selectedRowData.EmailAttachmentSecurityId,
      priority: 0,
      dateOverrideBy: selectedRowData.DateOverrideBy,
      ModifiedBy: 10039,

    };

    const response = await sbaAxios({
      url: `${EmailruleInsertorUpdate}`,
      method: "post",
      data: data,
    })
       
        if (response === -5000) {
            SBNotify({ type: "error", Msg: newName+" already exists" });
        }
        else {
            SBNotify({ type: "success", Msg: "Saved Successfully" });
            dispatch(getEmailRules(activeTab, null, true));
            setShowDrawer(false);
        }

   
    // setTimeout(() => {
    //   setRender(!render);
    // }, 1000);
  }; 
  return (
    <>
      <div id="emailrulesList">
        <div className="button-container">
          {ActiveButtons.map((option) => (
            <button
              key={option.value}
              value={option.value}
              className={`non-gappable-button  ${selectedButton === option.label
                ? "selected-non-gappable-button"
                : ""
                }`}
              onClick={() => fetchActiverecords(option.label)}
              disabled={option.disabled}
            >
              {option.label}
            </button>
          ))}
        </div>
        <div className="col-md-12 d-flex align-items-end justify-content-end">
          <button
            className="p-sm-btn mx-1"
            onClick={copyRuleOnClick}
            disabled={!isEdit}
          >
            Copy Rule
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={NavigatetoAddRule}
            disabled={!isEdit}
          >
            <i className="fa-plus fa-solid"></i>Add Rule
          </button>
        </div>

       <>
          {activeTab === 1 && <>
            <EmailRuleGrid  gridData={EmailRules} activeTab={activeTab}  selectedButton={selectedButton} rowSelection={"single"} onRowClicked={MainMenuRowClicked} componentID={component.InvestmentRuleList}/>
          </>}
          {activeTab === 2 &&
            <EmailRuleGrid gridData={EmailRules} activeTab={activeTab}  selectedButton={selectedButton}  rowSelection={"single"} onRowClicked={MainMenuRowClicked}  componentID={component.ClientRuleList} />}
          {activeTab === 3 &&
            <EmailRuleGrid gridData={EmailRules} activeTab={activeTab} selectedButton={selectedButton}  rowSelection={"single"}  onRowClicked={MainMenuRowClicked}  componentID={component.DeletionRuleList}/>}
              </>
              <ToastContainer></ToastContainer>
            </div>
      <SBADrawer
        open={showDrawer}
        setOpen={setShowDrawer}
        close={false}
        title={`Copy-${copiedName}`}
      >
        <div>
          <label className="header-container m-1">
            <b>Copied {copiedName}</b>
          </label>
          <div className="mb-4">
            <input className="form-control w-75" type="text" value={selectedRowData.EmailRuleName} />
          </div>

          <label className="header-container m-1">
            <b>New rule name</b>
          </label>
          <div className="mb-4">
            <input className="form-control w-75" type="text" onChange={(e) => setNewName(e.target.value)} />
          </div>

          <div className="mt-4">
            <button
              className="s-sm-btn mx-1"
              onClick={() => setShowDrawer(false)}
            >
              Cancel
            </button>
            <button className="p-sm-btn mx-1" onClick={saveNewRule}>
              Save
            </button>
          </div>
        </div>
      </SBADrawer>
     
    </>
  );
}
const DeleteEmailRuleModal = ({ setShowModal, selectedButton, showModal, isEdit, ruleId, activeTab }) => {
  const dispatch = useDispatch();
  const DeleteEmailRules = () => {

    sbaAxios({
      url: `${deleteEmailrule}${ruleId},${0}`,
      method: 'get',
    }).then(response => {
      SBNotify({ type: "success", Msg: 'Email Rules Deleted Successfully' });
      setTimeout(() => {
        if (selectedButton == "All") {
          dispatch(getEmailRules(activeTab, null, false));
        }
        else {
          dispatch(getEmailRules(activeTab, null, true));
        }
      }, 100);
    })
      .catch(error => {
        console.error('Error deleting data:', error);
      });
    setShowModal(false);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  return <>
    <Modal show={showModal}>
      <Modal.Header closeButton onClick={closeModal}>
        <Modal.Title>
          Do you want to delete the selected Email Rule?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          The selected Email Rule will be deleted permanently. Are you sure?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button className="s-sm-btn mx-1" onClick={closeModal}>
          Cancel
        </button>
        <button
          className="p-sm-btn mx-1"
          onClick={DeleteEmailRules}
          disabled={!isEdit}
        >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  </>
}
const getDateFormatted = (params) => {
  const isoDate = params.value;
  const formattedDate = moment(isoDate).format('MM-DD-YYYY');
  return formattedDate;
};
const EmailRuleGrid = ({ gridData,activeTab,selectedButton, componentID,...props }) => {
  const [colDef, setColDef] = useState();
  const [appliedFilter, setAppliedFilter] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [ruleId, setRuleId] = useState(null);
  const Gstate=useSelector(state=>state);
  const isEditable = Gstate.authorizationData.isEditable;
  const [isEdit,setIsEdit]=useState(isEditable);
  const [activeTabId,setActiveTabId]=useState(activeTab);
  const emailRuleRef=useRef();

  useEffect(()=>{setIsEdit(isEditable)},[isEditable]);
  useEffect(()=>{setActiveTabId(activeTab)},[activeTab]);
  useEffect(() => {
    fetchGridData();
  }, [activeTabId]);

  const fetchGridData = async () => {
    try {
      const customSettings = await getCustomSetting();
      setColDef(customSettings.columns);
      setAppliedFilter(customSettings.filters);
    } catch (error) {
      console.error("Error fetching custom settings:", error);
    }
  };
  const getCustomSetting = async () => {
    try {
      const response = await sbaAxios({ url: `${getCustomSettings}${componentID}` });
      if (response) {
        const apiColDef = JSON.parse(response.CustomSettingsValue);
        const apiFilters = JSON.parse(response.CustomFilterValue);
        const formattedDef = apiColDef.map(item => ({ ...item, "field": item.colId, cellRenderer: item.colId === "Action" ? ActionsRenderer : (item.colId === "CreatedDate" ||item.colId ===  "ModifiedDate" ) ? getDateFormatted : null }))
        return { columns: formattedDef, filters: apiFilters };
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  const ActionsRenderer = (props) => {
    const RuleId = props.data.EmailRuleId;
    const isactive = props.data.IsActive;
    const history = useNavigate();
    const SetdeleteId = () => {
      setShowModal(true);
      // setColDef(value=>value);
      setRuleId(RuleId);
    };
    const NavigatetoEdit = () => {
      history(`${UrlPath.EditEmailRules}${RuleId}`, {
        state: activeTabId
      });
    }
      return (
        <div className="actions-cell"> {isactive && <>
          <i className={(isEdit) ? "fas fa-edit" : "fas fa-edit disabledControl"} style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={() => { (isEdit) && NavigatetoEdit() }}></i>
          <i className={(isEdit) ? "fa fa-trash" : "fa fa-trash disabledControl"} style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={() => { (isEdit) && SetdeleteId() }} ></i>
        </>} </div>
      )
  };
  return <>
    <SBGrid ref={emailRuleRef} column={colDef} row={gridData} filters={appliedFilter} componentID={componentID} gridStyle={{ width: '100%', height: '70vh' }}  {...props} ></SBGrid>
    <DeleteEmailRuleModal setShowModal={setShowModal} selectedButton={selectedButton} showModal={showModal} isEdit={isEdit} ruleId={ruleId} activeTab={activeTabId} />
  </>
};

